import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-text-muted text-sm">
        Laddar session...
      </div>
    );
  }
  // user ar inloggad om antingen Supabase-session ELLER SSO-cookie validerade
  if (!user) {
    return <Navigate to="/login" state={{ redirect: location.pathname }} replace />;
  }
  return <>{children}</>;
}
